import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap"
          >
            <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-film-line text-background-50 text-lg"></i>
            </span>
            <span className="font-heading font-bold text-lg text-foreground-900 hidden sm:block">
              光影在线
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/')
                  ? 'text-primary-600'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/kehuan"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-600'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                isActive('/about')
                  ? 'text-primary-600'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 hover:bg-background-200 transition-colors cursor-pointer" aria-label="搜索">
              <i className="ri-search-line text-foreground-600 text-base"></i>
            </button>
          </div>

          <button
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 hover:bg-background-200 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-foreground-700 text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            <Link
              to="/"
              className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors ${
                isActive('/')
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/kehuan"
              className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors ${
                location.pathname.startsWith('/category')
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors ${
                isActive('/about')
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}